import { render, staticRenderFns } from "./DamageAssessorCaseAccidentCard.vue?vue&type=template&id=08ca9687&scoped=true"
import script from "./DamageAssessorCaseAccidentCard.vue?vue&type=script&lang=js"
export * from "./DamageAssessorCaseAccidentCard.vue?vue&type=script&lang=js"
import style0 from "./DamageAssessorCaseAccidentCard.vue?vue&type=style&index=0&id=08ca9687&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ca9687",
  null
  
)

export default component.exports